module.exports = __webpack_public_path__ + "img/target.4b5d133b.svg";